"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Publish_1 = __importDefault(require("@material-ui/icons/Publish"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var Utils = __importStar(require("../../utils"));
var labelDefault = 'Upload File';
var messageDefault = 'You successfully uploaded the file';
var useSnackbar = Utils.useSnackbar;
exports["default"] = (function (_a) {
    var _b = _a.label, label = _b === void 0 ? labelDefault : _b, _c = _a.message, message = _c === void 0 ? messageDefault : _c, promise = _a.promise, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var _e = react_1.useState(false), loading = _e[0], setLoading = _e[1];
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var handleChange = function (e) {
        setLoading(true);
        if (!e.target || !e.target.files) {
            throw Error('file is undefined');
        }
        var files = e.target.files;
        var fileArray = Array.from(files);
        if (fileArray.length === 0) {
            throw Error('file array is empty');
        }
        var file = fileArray[0];
        promise(file).then(function () {
            setLoading(false);
            Utils.confirmMessage(enqueueSnackbar, message, 'success');
        });
    };
    if (loading)
        return react_1["default"].createElement(CircularProgress_1["default"], { color: "primary" });
    return (react_1["default"].createElement(Button_1["default"], { disabled: disabled, color: "primary", variant: "contained", component: "label" },
        react_1["default"].createElement(Publish_1["default"], null),
        " ",
        label,
        react_1["default"].createElement("input", { type: "file", style: { display: 'none' }, onChange: handleChange })));
});
